import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./mineralPrint.scss";
import { getSingleMineralEntry } from "../../../modules/actions/dataEntryActions";
import { mineralSampleSuccess } from "../../../modules/actions/mineralActions";
import logo from "../../../Images/Logo 2.png";
import { mineralAnalysisTypes } from "../../constant/constant";

function MineralPrint(props) {
    const [printObj, setPrintObj] = useState({});
    const [entryNumber, setEntryNumber] = useState("");

    useEffect(() => {
        props.mineralSampleSuccess(false);
    }, []);

    useEffect(() => {
        const entry = props.singleEntry || {};
        const mineralSample = entry.mineralSample || entry;
        const customer = entry.customer || {};
        setPrintObj({
            ...mineralSample,
            entryNo: entry.entryNo || mineralSample.entryNo,
            entryDate: entry.entryDate || mineralSample.entryDate,
            customerName: entry.customerName || mineralSample.customerName || customer.customerName,
            companyName: entry.companyName || customer.companyName || mineralSample.companyName,
            contactNo: entry.contactNo || customer.mobileNo || mineralSample.contactNo,
            totalAmount: entry.totalAmount || mineralSample.totalAmount,
            advance: entry.advance || mineralSample.advance,
            balance: entry.balance || (entry.totalAmount - entry.advance),
            sampleType: mineralSample.sampleType,
            sampleTypeOther: mineralSample.sampleTypeOther,
            quantityWeight: mineralSample.quantityWeight,
            descriptionMarks: mineralSample.descriptionMarks,
            requestedAnalysis: mineralSample.requestedAnalysis || [],
            otherAnalysis: mineralSample.otherAnalysis
        });
    }, [props.singleEntry]);

    useEffect(() => {
        if (props.history) {
            setEntryNumber(props.history.location.pathname.split("/")[2]);
        }
    }, [props]);

    useEffect(() => {
        if (entryNumber) {
            props.getSingleMineralEntry(entryNumber);
        }
    }, [entryNumber]);

    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const day = d.getDate();
        const month = d.getMonth() + 1;
        const year = d.getFullYear();
        return `${day < 10 ? '0' + day : day} / ${month < 10 ? '0' + month : month} / ${year}`;
    };

    const printElem = () => {
        const sTable = document.getElementById("main").innerHTML;
        const win = window.open("", "_blank");

        const style = `<style>
            * { box-sizing: border-box; margin: 0; padding: 0; }
            @page { size: A4; margin: 6mm 10mm; }
            body {
                -webkit-print-color-adjust: exact;
                font-family: Arial, sans-serif;
                font-size: 9px;
                color: #000;
                background: #fff;
            }
            .mineralReceiptPage { width: 100%; }
            .mineralReceiptInner { width: 100%; }
            .mineralReceiptCopy { width: 100%; padding: 3px 0; }
            .rcpt-header { display: flex; align-items: center; margin-bottom: 6px; }
            .rcpt-logo { width: 52px; height: 52px; margin-right: 10px; flex-shrink: 0; }
            .rcpt-logo img { width: 100%; height: 100%; object-fit: contain; }
            .rcpt-title-block { flex: 1; text-align: center; }
            .rcpt-main-title { font-size: 16px; font-weight: bold; letter-spacing: 0.3px; margin-bottom: 2px; }
            .rcpt-subtitle { font-size: 9px; }
            .rcpt-info-table { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
            .rcpt-info-table td { border: 1px solid #000; padding: 3px 6px; font-size: 9px; vertical-align: middle; }
            .rcpt-info-label { width: 105px; white-space: nowrap; }
            .rcpt-section { margin-bottom: 6px; }
            .rcpt-section-title { font-weight: bold; font-style: italic; font-size: 10px; text-decoration: underline; margin-bottom: 4px; }
            .rcpt-field-line { display: inline-block; border-bottom: 1px solid #000; min-width: 120px; height: 12px; vertical-align: bottom; }
            .rcpt-desc-line { display: block; border-bottom: 1px solid #000; width: 100%; height: 14px; margin-top: 3px; padding-left: 4px; }
            .rcpt-analysis-row { display: flex; flex-wrap: wrap; font-size: 9px; }
            .rcpt-analysis-item { width: 50%; display: flex; align-items: center; padding: 1px 0; }
            .rcpt-analysis-item-full { width: 100%; display: flex; align-items: center; padding: 1px 0; }
            .rcpt-cb { display: inline-block; width: 10px; height: 10px; border: 1.5px solid #000; margin-right: 4px; flex-shrink: 0; text-align: center; line-height: 8px; font-size: 8px; }
            .rcpt-cb-checked { background: #000; color: #fff; }
            .rcpt-payment-table { width: 100%; border-collapse: collapse; margin-bottom: 6px; }
            .rcpt-payment-table td { padding: 2px 6px; font-size: 9px; }
            .rcpt-payment-table td:last-child { text-align: right; font-weight: bold; }
            .rcpt-payment-total td { border-top: 1px solid #000; font-weight: bold; }
            .rcpt-ack { margin-bottom: 5px; }
            .rcpt-ack p { font-size: 9px; margin-bottom: 2px; }
            .rcpt-sig-row { display: flex; gap: 20px; margin-top: 4px; }
            .rcpt-sig-field { display: flex; align-items: center; gap: 5px; font-size: 9px; }
            .rcpt-sig-line { display: inline-block; border-bottom: 1px solid #000; width: 130px; height: 14px; }
            .rcpt-note { font-size: 8px; font-style: italic; margin-top: 5px; }
            .rcpt-cut-line { border: none; border-top: 2px dashed #555; margin: 8px 0; }
        </style>`;

        win.document.write("<html><head>");
        win.document.write("<title>Mineral Sample Collection Receipt</title>");
        win.document.write(style);
        win.document.write("</head><body>");
        win.document.write('<div id="main" class="mineralReceiptPage">');
        win.document.write(sTable);
        win.document.write("</div>");
        win.document.write("</body></html>");

        win.document.close();
        setTimeout(() => {
            win.print();
        }, 600);
    };

    const renderAnalysisCheckbox = (analysis) => {
        const requestedArr = printObj.requestedAnalysis || [];
        const isChecked = requestedArr.indexOf(analysis) !== -1;
        return isChecked;
    };

    const renderReceiptCopy = (copyType) => (
        <div className="mineralReceiptCopy">
            {/* Header */}
            <div className="rcpt-header">
                <div className="rcpt-logo">
                    <img src={logo} alt="GMTL Logo" />
                </div>
                <div className="rcpt-title-block">
                    <div className="rcpt-main-title">GMTL – Sample Collection Receipt</div>
                    <div className="rcpt-subtitle">
                        GMTL – Gemological &amp; Mineral Testing Laboratory Karachi, Pakistan
                    </div>
                </div>
            </div>

            {/* Info Table */}
            <table className="rcpt-info-table">
                <tbody>
                    <tr>
                        <td className="rcpt-info-label">Receipt No:</td>
                        <td style={{ width: "38%" }}>{printObj.entryNo}</td>
                        <td className="rcpt-info-label" style={{ width: "55px" }}>Date:</td>
                        <td>{formatDate(printObj.entryDate)}</td>
                    </tr>
                    <tr>
                        <td className="rcpt-info-label">Customer Name:</td>
                        <td colSpan={3}>{printObj.customerName}</td>
                    </tr>
                    <tr>
                        <td className="rcpt-info-label">Company Name:</td>
                        <td colSpan={3}>{printObj.companyName || ""}</td>
                    </tr>
                    <tr>
                        <td className="rcpt-info-label">Contact No:</td>
                        <td colSpan={3}>{printObj.contactNo || ""}</td>
                    </tr>
                </tbody>
            </table>

            {/* Sample Details */}
            <div className="rcpt-section">
                <div className="rcpt-section-title">Sample Details</div>
                <p style={{ fontSize: 10, marginBottom: 4, lineHeight: 1.6 }}>
                    Type: Mineral / Ore / Rock / Other:&nbsp;
                    <span className="rcpt-field-line">
                        {printObj.sampleType === "Other" ? printObj.sampleTypeOther : printObj.sampleType}
                    </span>
                </p>
                <p style={{ fontSize: 10, marginBottom: 4, lineHeight: 1.6 }}>
                    Quantity / Weight:&nbsp;
                    <span className="rcpt-field-line">{printObj.quantityWeight}</span>
                </p>
                <p style={{ fontSize: 10, marginBottom: 2, lineHeight: 1.6 }}>Description / Identification Marks:</p>
                <span className="rcpt-desc-line">{printObj.descriptionMarks || ""}</span>
                <span className="rcpt-desc-line"></span>
            </div>

            {/* Requested Analysis */}
            <div className="rcpt-section">
                <div className="rcpt-section-title">Requested Analysis</div>
                <div className="rcpt-analysis-row">
                    {mineralAnalysisTypes.map((analysis, index) => (
                        <div className="rcpt-analysis-item" key={index}>
                            <span className={`rcpt-cb${renderAnalysisCheckbox(analysis) ? " rcpt-cb-checked" : ""}`}>
                                {renderAnalysisCheckbox(analysis) ? "✓" : ""}
                            </span>
                            {analysis}
                        </div>
                    ))}
                    <div className="rcpt-analysis-item-full">
                        <span className={`rcpt-cb${printObj.otherAnalysis ? " rcpt-cb-checked" : ""}`}>
                            {printObj.otherAnalysis ? "✓" : ""}
                        </span>
                        Other:&nbsp;<span className="rcpt-field-line" style={{ minWidth: 120 }}>{printObj.otherAnalysis || ""}</span>
                    </div>
                </div>
            </div>

            {/* Payment */}
            <div className="rcpt-section">
                <table className="rcpt-payment-table">
                    <tbody>
                        <tr>
                            <td>Total Amount:</td>
                            <td>{printObj.totalAmount}/-</td>
                        </tr>
                        <tr>
                            <td>Advance:</td>
                            <td>{printObj.advance}/-</td>
                        </tr>
                        <tr className="rcpt-payment-total">
                            <td>Balance:</td>
                            <td>{printObj.balance || (printObj.totalAmount - printObj.advance)}/-</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Customer Acknowledgment */}
            <div className="rcpt-ack">
                <p><strong>Customer Acknowledgment</strong></p>
                <p>I confirm that the above samples have been submitted and details are correct.</p>
                <div className="rcpt-sig-row">
                    <div className="rcpt-sig-field">
                        Name:&nbsp;<span className="rcpt-sig-line"></span>
                    </div>
                    <div className="rcpt-sig-field">
                        Signature:&nbsp;<span className="rcpt-sig-line"></span>
                    </div>
                </div>
            </div>

            <p className="rcpt-note"><em>Note: This receipt must be presented at the time of collection.</em></p>


        </div>
    );

    return (
        <>
            {props.dataEntryLoading ? (
                <div className="loaderDiv tableLoader">
                    <div>
                        <img src={logo} />
                    </div>
                </div>
            ) : null}

            <div className="mineralReceiptPage">
                <div className="mineralPrintHeader">
                    <button className="printReciptBtn" onClick={printElem}>
                        Print Receipt
                    </button>
                    <button
                        className="backReciptBtn"
                        onClick={() => props.history.goBack()}
                    >
                        Back
                    </button>
                </div>

                <div id="main" className="mineralReceiptInner">
                    {renderReceiptCopy("office")}
                    <hr className="rcpt-cut-line" style={{ border: "none", borderTop: "2px dashed #555", margin: "14px 0" }} />
                    {renderReceiptCopy("customer")}
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        singleEntry: state.dataEntry.singleEntry,
        dataEntryLoading: state.dataEntry.dataEntryLoading
    };
};

const mapDispatchToProps = (dispatch) => ({
    getSingleMineralEntry: (entryNo) => dispatch(getSingleMineralEntry(entryNo)),
    mineralSampleSuccess: (bool) => dispatch(mineralSampleSuccess(bool))
});

export default connect(mapStateToProps, mapDispatchToProps)(MineralPrint);